'use strict'

module.exports = (function () {
    /**
    * @ngdoc method
    * @name initializeAccordions
    * @description Setup an accordion.  Event handlers, etc
    **/

    var initializeAccordions = function () {

        $('.get-accordion-expand').on('click', function (e) {
            e.preventDefault();

            var accordionId = $(this).attr("data-id");

            $(accordionId + " .collapse:not(.in)").collapse('show');
            $(accordionId + " [data-toggle='collapse']").removeClass('collapsed');

            return false;
        });

        $('.get-accordion-collapse').on('click', function (e) {
            e.preventDefault();

            var accordionId = $(this).attr("data-id");

            $(accordionId + " .collapse.in").collapse('hide');
            $(accordionId + " [data-toggle='collapse']").addClass('collapsed');

            return false;
        });

        console.log("accordion initialized");
    };

    // Return an object exposing the public items
    return {
        initialize: initializeAccordions
    };
}())